export default {
    namespaced: true,
    state: () => ({
        loading: false,
        categoriesPanelOpen: false,
        sessionReady: false,
        cartReady: false,
    }),
    getters: {

    },
    mutations: {
        setLoading (state, status) {
            state.loading = !!status;
        },
        setSessionReady(state, status) {
            state.sessionReady = !!status;
        },
        setCartReady(state, status) {
            state.cartReady = !!status;
        },
        setCategoriesPanelOpen(state, open) {
            state.categoriesPanelOpen = !!open;
            document.body.classList.toggle('openCategoriesPanel', state.categoriesPanelOpen);

            if (state.categoriesPanelOpen) {
                document.body.classList.remove('openMenu');
            }

            if (!state.categoriesPanelOpen) {
                document.body.classList.remove('noScroll');
            }
        },
    }
}
